//@ts-expect-error Untyped import
import { getDataType } from 'reporting-data/public/get-data-type';
import { getDataType as eventSafeGetDataType } from 'reporting-data/report/configReportGetters';
import { DATA_TYPE_TO_HUBSPOT_OBJECT_COORDINATES } from 'reporting-data/constants/objectCoordinates';
const getConfigDataType = report => {
  const dataType = getDataType(report);
  return DATA_TYPE_TO_HUBSPOT_OBJECT_COORDINATES.get(dataType) || eventSafeGetDataType(report);
};
export default getConfigDataType;